const CURRENCY_SYMBOLS = {
  KES: 'KSh', USD: '$', EUR: '€', GBP: '£', TZS: 'TSh', UGX: 'USh', ZAR: 'R',
};

// Module-level decimal defaults. AuthContext calls setDecimalConfig() after
// loading settings so every formatter in the app picks up the company's chosen
// precision without requiring changes to individual call sites.
let _priceDp = 2;
let _qtyDp = 2;

export const setDecimalConfig = ({ qty = 2, price = 2 } = {}) => {
  _priceDp = Math.max(0, Math.min(6, Number.isFinite(Number(price)) ? Number(price) : 2));
  _qtyDp = Math.max(0, Math.min(6, Number.isFinite(Number(qty)) ? Number(qty) : 2));
};

export const getDecimalConfig = () => ({ qty: _qtyDp, price: _priceDp });

const formatNumber = (amount, dp) => {
  const resolvedDp = Number.isFinite(dp) ? dp : _priceDp;
  if (amount === null || amount === undefined) return Number(0).toFixed(resolvedDp);
  const num = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (isNaN(num)) return Number(0).toFixed(resolvedDp);
  return num.toLocaleString('en-KE', {
    minimumFractionDigits: resolvedDp,
    maximumFractionDigits: resolvedDp,
  });
};

/**
 * Format a monetary amount: KSh 1,250,000.00 (or $ / € etc.)
 * Pass options.dp to override the configured price decimal places for one-off display.
 */
export const formatCurrency = (amount, currency = 'KES', options = {}) => {
  const { showSymbol = true, dp } = options;
  const symbol = CURRENCY_SYMBOLS[currency] || currency;
  const formattedNumber = formatNumber(amount, dp);
  return showSymbol ? `${symbol} ${formattedNumber}` : formattedNumber;
};

/** Format a monetary amount without currency symbol. */
export const formatAmount = (amount, dp) => formatNumber(amount, dp);

/** Format a quantity value using the configured quantity decimal places. */
export const formatQuantity = (qty, dp) => {
  const resolvedDp = Number.isFinite(dp) ? dp : _qtyDp;
  return formatNumber(qty, resolvedDp);
};

/**
 * Parse a currency string back to a number.
 */
export const parseCurrency = (str) => {
  if (!str) return 0;
  return parseFloat(String(str).replace(/[^0-9.-]/g, '')) || 0;
};
